// extracted by mini-css-extract-plugin
export default {"cls1":"Comments-cls1___6b9d478d28ed854e72f","cls2":"Comments-cls2___62d963e1005bff89523 Comments-cls1___6b9d478d28ed854e72f"};